import { todayInCostaRica } from "/home/runner/work/sosdigital-pindrop/sosdigital-pindrop/packages/frontend/ui/src/format/index.ts";

const MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;

/** `?month=` must be `YYYY-MM`; anything else means "current month". */
export function isMonthKey(value: unknown): value is string {
  return typeof value === "string" && MONTH_RE.test(value);
}

/** FR-FE15-06: the current month in Costa Rica time, as `YYYY-MM`. */
export function currentMonthKey(now: Date = new Date()): string {
  return todayInCostaRica(now).slice(0, 7);
}

/** FR-FE15-08: the current month and the previous ones, newest first (`count` in total). */
export function recentMonthKeys(count: number, current: string = currentMonthKey()): string[] {
  const [y, m] = current.split("-").map(Number) as [number, number];
  const keys: string[] = [];
  let year = y;
  let month = m;
  for (let i = 0; i < count; i += 1) {
    keys.push(`${year}-${String(month).padStart(2, "0")}`);
    month -= 1;
    if (month === 0) {
      month = 12;
      year -= 1;
    }
  }
  return keys;
}

/** Kicker "SOS Sitios · mm/aaaa": `2026-10` → `10/2026`. */
export function formatMonthKicker(key: string): string {
  const [year, month] = key.split("-");
  return `${month}/${year}`;
}
